import React from "react";
import { useTranslation } from "react-i18next";
import { MailInboxApiService } from "src/services/mail-inbox/mail-inbox-api.service";
import { Props, MailInboxQuickFilter, MailInboxOptionValue } from "./interfaces";

import AutocompleteQuickFilter from "../../../reusable-components/AutocompleteQuickFilter/AutocompleteQuickFilter";

export const MailInboxQuickfilter = ({ quickFilters, handleChangeQuickFilters, customPropsFilter }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.mail_inbox";

  const quickFilter: keyof MailInboxQuickFilter = "mailInboxes";
  const quickFilterOptionValueKey: keyof MailInboxOptionValue = "mailInboxIds";

  return (
    <AutocompleteQuickFilter
      serviceApi={new MailInboxApiService()}
      quickFilters={quickFilters}
      quickFilter={quickFilter}
      quickFilterOptionValueKey={quickFilterOptionValueKey}
      handleChangeQuickFilter={handleChangeQuickFilters}
      propsFilter={{ ...customPropsFilter }}
      customLabelStyle={{
        width: "60px",
      }}
      customTextfieldStyle={
        {
          maxWidth: "380px",
          backgroundColor: "transparent",
          border: "0.5px solid grey",
          borderRadius: "5px",
          "& .MuiAutocomplete-input": {
            minWidth: "270px !important",
            fontSize: "22px",
          },
        } as React.CSSProperties
      }
      includeLogo={{
        logoKey: "logo",
        logoTypeKey: "logoFileType",
      }}
    />
  );
};
